import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Box, Checkbox, Column, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { relationshipModel } from '~/models';
import AllSetPageWithAnimations from '../../../../AllSetStep/AllSetPageWithAnimations';
import { getStepName, stepsTextsPath } from '../../../../ClientOnboarding.utils';
import PendingAdditionalSignaturesWithAnimations from '../../../../RelationshipSignedStep/PendingAdditionalSignaturesWithAnimations';
import { contentTransition, contentVariants } from '../animations';
import { StepContent } from '../StepContent';
import { GetStepsContainerTID } from './StepsContainer';
import styles from './StepsContainerMobile.module.scss';
export const StepsContainerMobile = (param)=>{
    let { testId, currentStep, direction, relationship, statement, isStatementAccepted, onStatementChange, hasSignedSuccess } = param;
    const { StepsContainerTestIds } = useMemo(()=>GetStepsContainerTID(testId), [
        testId
    ]);
    const { t: stepsTexts } = useLocaleKeys(stepsTextsPath);
    const stepTitle = useMemo(()=>getStepName(currentStep, relationship, stepsTexts), [
        currentStep,
        relationship,
        stepsTexts
    ]);
    const showCheckbox = statement && onStatementChange && !hasSignedSuccess;
    const signedSuccessContent = hasSignedSuccess && /*#__PURE__*/ _jsx(motion.div, {
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        },
        transition: {
            duration: 0.3,
            ease: 'linear'
        },
        className: styles.motionWrapper,
        children: relationshipModel.isApproved(relationship) ? /*#__PURE__*/ _jsx(AllSetPageWithAnimations, {
            relationship: relationship
        }) : /*#__PURE__*/ _jsx(PendingAdditionalSignaturesWithAnimations, {})
    }, "signed-success");
    return /*#__PURE__*/ _jsx(Box, {
        className: styles.gradientWrapper,
        testId: StepsContainerTestIds.Root(),
        children: /*#__PURE__*/ _jsx(Column, {
            className: styles.inner,
            children: /*#__PURE__*/ _jsx(Column, {
                className: styles.content,
                testId: StepsContainerTestIds.Content(),
                children: /*#__PURE__*/ _jsx(AnimatePresence, {
                    initial: false,
                    mode: "wait",
                    custom: direction,
                    children: hasSignedSuccess ? signedSuccessContent : /*#__PURE__*/ _jsxs(motion.div, {
                        custom: direction,
                        variants: contentVariants,
                        initial: "enter",
                        animate: "center",
                        exit: "exit",
                        transition: contentTransition,
                        className: styles.motionWrapper,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h3",
                                weight: "normal",
                                className: styles.stepTitle,
                                testId: StepsContainerTestIds.StepTitle(),
                                children: stepTitle
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.stepContent,
                                children: /*#__PURE__*/ _jsx(StepContent, {
                                    currentStep: currentStep
                                })
                            }),
                            showCheckbox && /*#__PURE__*/ _jsx("div", {
                                className: styles.checkboxWrapper,
                                children: /*#__PURE__*/ _jsx(Checkbox, {
                                    className: styles.statementCheckbox,
                                    onChange: (e)=>onStatementChange(e.target.checked),
                                    testId: StepsContainerTestIds.Footer() + '-checkbox',
                                    checked: isStatementAccepted,
                                    bi: {
                                        name: 'accept_statement'
                                    },
                                    children: /*#__PURE__*/ _jsx(Typography, {
                                        variant: "paragraph1",
                                        weight: "light",
                                        children: statement
                                    })
                                })
                            })
                        ]
                    }, currentStep)
                })
            })
        })
    });
};
